import { render, staticRenderFns } from "./AdResources.vue?vue&type=template&id=4bd6c520&scoped=true"
import script from "./AdResources.vue?vue&type=script&lang=js"
export * from "./AdResources.vue?vue&type=script&lang=js"
import style0 from "./AdResources.vue?vue&type=style&index=0&id=4bd6c520&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd6c520",
  null
  
)

export default component.exports